import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export default styled((props) => <Typography {...props} />)(({ theme }) => ({
    fontFamily: 'Inter',
    color: '#585757',
    fontSize: '14px',
}));
